import * as React from 'react'

function SvgChevronLeft(props) {
  return (
    <svg
      width={5}
      height={8}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.61 4L4.47 6.862a.667.667 0 11-.942.943L.195 4.47a.667.667 0 010-.942L3.53.195a.667.667 0 11.942.943L1.61 4z"
        fill="#1557BF"
      />
    </svg>
  )
}

export default SvgChevronLeft
